import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { ContentCardComponent } from '../content-card/content-card.component';
import { GtagService } from '../../../common/gtag/gtag.service';
import { FeaturedCardComponent } from '../featured-card/featured-card.component';

@Component({
  selector: 'sharry-content-card-list',
  standalone: true,
  imports: [ContentCardComponent, FeaturedCardComponent],
  templateUrl: './content-card-list.component.html',
  styleUrls: ['./content-card-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentCardListComponent extends BaseComponent implements OnChanges {
  @Input() cards: any[] = [];
  @Input() classes = '';
  @Input() cardClasses = '';
  @Input() mode: 'sharryContent' | 'sharryAttendance' | 'template' = 'sharryContent'; // used only in layout = sharry
  @Input() collectionId: string;
  cardsType: string;

  constructor(private gtagService: GtagService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.cards?.currentValue) {
      this.cardsType = this.cards && this.cards.length > 0 ? this.cards[0].contentType : null;
      const items = this.cards.map((card: any) => ({
        item_name: card?.title,
        item_id: card?.id,
        ...(card?.contentType === 'sharry' && { price: card?.nextUpcomingVariant?.discountedPrice }),
        item_brand:
          card?.__typename === 'FeaturedCard'
            ? 'Ruralis'
            : card?.contentType === 'wonder'
              ? 'Wonder'
              : card?.owner?.businessName,
        item_category: card?.sharryKind?.name,
        item_variant: card?.sharrySelection,
      }));
      this.gtagService.pushEvent(
        {
          event: 'view_item_list',
          ecommerce: {
            items: items,
          },
        },
        true,
      );
    }
  }

  onChangedBookmarked($event: any) {
    this.cards = this.cards.map(card => (card.id === $event.id ? { ...card, bookmarked: $event.bookmarked } : card));
  }
}
